// Hierarquia de planos do parceiro. Quanto maior o rank, mais recursos.
export type PartnerPlan = "essential" | "connect" | "pro" | "imob";

export const PLAN_RANK: Record<PartnerPlan, number> = {
  essential: 1,
  connect: 2,
  pro: 3,
  imob: 3, // Imob equivale ao Pro em acessos
};

export const PLAN_LABEL: Record<PartnerPlan, string> = {
  essential: "Acelera Start",
  connect: "Acelera Connect",
  pro: "Acelera Pro",
  imob: "Acelera Imob",
};

// Mapa de rotas restritas → plano mínimo necessário.
// Rotas que NÃO aparecem aqui são liberadas para todos os planos.
export const ROUTE_MIN_PLAN: Record<string, PartnerPlan> = {
  // Indicações liberadas para todos os planos
  // Simulador Minha Casa Minha Vida liberado para todos os planos
  "/dashboard/crm": "pro",
  "/dashboard/kanban": "pro",
};

export function hasPlanAccess(
  currentPlan: PartnerPlan | null | undefined,
  requiredPlan: PartnerPlan
): boolean {
  if (!currentPlan) return false;
  return PLAN_RANK[currentPlan] >= PLAN_RANK[requiredPlan];
}

export function getRequiredPlanForRoute(path: string): PartnerPlan | null {
  return ROUTE_MIN_PLAN[path] ?? null;
}
